import { render, staticRenderFns } from "./msgRecharge.vue?vue&type=template&id=620ca5dc&scoped=true&"
import script from "./msgRecharge.vue?vue&type=script&lang=js&"
export * from "./msgRecharge.vue?vue&type=script&lang=js&"
import style0 from "./msgRecharge.vue?vue&type=style&index=0&id=620ca5dc&scoped=true&lang=css&"
import style1 from "./msgRecharge.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ca5dc",
  null
  
)

export default component.exports